interface ToggleProps {
  id: string;
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string;
  description?: string;
}

// 공개 설정용 토글 스위치
export default function Toggle({
  id,
  checked,
  onChange,
  label,
  description,
}: ToggleProps) {
  return (
    <label
      htmlFor={id}
      className="flex cursor-pointer items-start justify-between gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-background-300"
    >
      <span className="min-w-0">
        <span className="block text-sm font-semibold text-foreground-800">
          {label}
        </span>
        {description && (
          <span className="mt-0.5 block text-xs text-foreground-500">
            {description}
          </span>
        )}
      </span>
      <span
        className={`relative mt-0.5 inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors ${
          checked ? "bg-primary-500" : "bg-background-300"
        }`}
      >
        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="sr-only"
        />
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-background-50 transition-transform ${
            checked ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </span>
    </label>
  );
}